// extracted by mini-css-extract-plugin
export default {"inputsBox":"ForgotPasswordForm_inputsBox__dDC5Q","submitButtonBox":"ForgotPasswordForm_submitButtonBox__t7-Ys"};